export default "__VITE_ASSET__DDp6JL5a__"